import { render, staticRenderFns } from "./CrearEditar.vue?vue&type=template&id=dccf47a4&"
import script from "./CrearEditar.vue?vue&type=script&lang=js&"
export * from "./CrearEditar.vue?vue&type=script&lang=js&"
import style0 from "./CrearEditar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports